import { render } from "./UsersProviders.vue?vue&type=template&id=49aa59fa&scoped=true&lang=pug"
import script from "./UsersProviders.vue?vue&type=script&lang=js"
export * from "./UsersProviders.vue?vue&type=script&lang=js"

import "./UsersProviders.vue?vue&type=style&index=0&id=49aa59fa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa59fa"]])

export default __exports__